exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pointer[data-v-eb6d48de]{cursor:pointer}", ""]);

// exports
